(() => {
  if (window.__pk18LiveCollage) return;
  window.__pk18LiveCollage = true;

  const getRoot = () => document.querySelector('product-info.pk18-collage-mode');
  const prefersReduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (v,min,max) => Math.max(min,Math.min(max,v));
  let currentRoot = null;
  let ribbonVisible = false;
  let ribbonTop = -1;
  let pending = false;

  function assignPalette(root){
    if(root.dataset.pk18PaletteInit==='true')return;
    root.dataset.pk18PaletteInit='true';
    if(root.dataset.pi03Palette !== 'auto') return;
    const source=root.dataset.pi03PaletteImage;
    if(!source)return;
    const sample = new Image();
    sample.crossOrigin='anonymous';
    sample.onload = () => {
      try {
        const canvas=document.createElement('canvas');
        canvas.width=32;canvas.height=32;
        const ctx=canvas.getContext('2d',{willReadFrequently:true});
        if(!ctx)return;
        ctx.drawImage(sample,0,0,32,32);
        const colors=ctx.getImageData(0,0,32,32).data;
        const buckets=new Map();
        for(let i=0;i<colors.length;i+=8){
          if(colors[i+3]<220)continue;
          const red=colors[i]/255, green=colors[i+1]/255, blue=colors[i+2]/255;
          const high=Math.max(red,green,blue), low=Math.min(red,green,blue);
          const diff=high-low, brightness=(high+low)/2;
          if(diff<.065||brightness<.14||brightness>.87)continue;
          const saturation=diff/(1-Math.abs(2*brightness-1));
          if(saturation<.1)continue;
          const h=high===red?((green-blue)/diff)%6:high===green?(blue-red)/diff+2:(red-green)/diff+4;
          const hue=(h*60+360)%360;
          const key=Math.floor(hue/30);
          const entry=buckets.get(key)||{weight:0,totalHue:0};
          const weight=Math.pow(saturation,1.5);
          entry.weight+=weight;entry.totalHue+=hue*weight;
          buckets.set(key,entry);
        }
        const winning=[...buckets.values()].sort((a,b)=>b.weight-a.weight)[0];
        if(!winning||winning.weight<.7)return;
        const hue=Math.round(winning.totalHue/winning.weight);
        root.style.setProperty('--pi14-a',`hsl(${hue} 27% 28%)`);
        root.style.setProperty('--pi14-b',`hsl(${hue} 26% 14%)`);
        root.style.setProperty('--pi14-glow',`hsla(${hue},58%,72%,.20)`);
      }catch(error){ /* Named and neutral artwork palettes remain usable. */ }
    };
    sample.onerror=()=>{};
    sample.src=source;
  }

  function activateBanner(root){
    const banner=root.querySelector('[data-pk18-live]');
    if(!banner)return;
    if(prefersReduced())return;
    if('IntersectionObserver' in window){
      if(root._pk18Observer)return;
      const obs=new IntersectionObserver(entries=>{
        for(const e of entries){
          e.target.classList.toggle('pk18-live--active',e.isIntersecting);
        }
      },{rootMargin:'30px 0px',threshold:0});
      obs.observe(banner);
      root._pk18Observer=obs;
    }else{
      banner.classList.add('pk18-live--active');
    }
  }

  function refreshRibbon(){
    const root=getRoot();
    if(!root)return;
    const ribbon=root.querySelector('[data-pi14-follow]');
    const gallery=root.querySelector('[id^="pi03-product-focus-"]');
    const banner=root.querySelector('[data-pk18-live]');
    if(!ribbon||!gallery||!banner)return;
    const vh=window.innerHeight;
    const galleryRect=gallery.getBoundingClientRect();
    const bannerRect=banner.getBoundingClientRect();
    const nextScene=root.querySelector('.pi05-still, .pi15-film-room, .pi05-finale');
    const nextTop=nextScene?.getBoundingClientRect()?.top??Infinity;
    const shouldShow=!prefersReduced() &&
      bannerRect.bottom < vh*.3 &&
      galleryRect.top < vh*.48 &&
      galleryRect.bottom > 95 &&
      nextTop > vh*.32;
    if(shouldShow!==ribbonVisible){
      ribbonVisible=shouldShow;
      ribbon.classList.toggle('pi14-follow--visible',shouldShow);
      ribbon.setAttribute('aria-hidden',shouldShow?'false':'true');
      ribbon.inert=!shouldShow;
    }
    if(shouldShow){
      const header=document.querySelector('.section-header');
      const bottom=header?.getBoundingClientRect()?.bottom??0;
      const top=clamp(Math.round(bottom),0,95);
      if(top!==ribbonTop){
        ribbonTop=top;
        ribbon.style.setProperty('--pi14-ribbon-top',top+'px');
      }
    }
  }
  function onScroll(){
    if(pending)return;
    pending=true;
    requestAnimationFrame(()=>{
      pending=false;
      refreshRibbon();
    });
  }
  function initializeSmoothCTA(root){
    const link=root.querySelector('[data-pk18-scroll-to-gallery]');
    if(!link || link.dataset.pk18ScrollBound==='true')return;
    link.dataset.pk18ScrollBound='true';
    link.addEventListener('click',(event)=>{
      // Preserve native navigation for modified clicks and browser fallback.
      if(event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (event.button!==undefined && event.button!==0))return;
      const target=root.querySelector('[id^="pi03-product-focus-"]');
      if(!target)return;
      event.preventDefault();
      // Native browser-controlled interpolation: no animation frame scroll loop.
      target.scrollIntoView({
        behavior:prefersReduced()?'instant':'smooth',
        block:'start'
      });
    });
  }
  function initialize(){
    const root=getRoot();
    if(!root)return;
    if(currentRoot!==root){
      currentRoot=root;
      ribbonVisible=false;
      ribbonTop=-1;
    }
    assignPalette(root);
    activateBanner(root);
    initializeSmoothCTA(root);
    onScroll();
  }
  // No wheel/touch interceptors, no forced scroll positions and no scene locking.
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',onScroll,{passive:true});
  window.addEventListener('pageshow',onScroll);
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('DOMContentLoaded',initialize);
  if(document.readyState!=='loading')initialize();
})();